import React from 'react';
import Layout from '../Layout/Layout';
import PageHeader from '../PageHeader/PageHeader';
import UploadFiles from './PortalUploadFiles'
import { Block } from '../../styles/commons'

const UploadScreen = props => {
  return (
    <Layout product='portal'>
      <PageHeader title='DreamEx Connect File Upload'/>
      <Block>
      <UploadFiles/>

      </Block>
        {/* <textarea rows={25} cols={132} value={text} readOnly/> */}
    </Layout>
  )
}

// const Instructions = styled.p`
//   color: #333;
//   font-weight: 500;
//   display: inline-block;
//   vertical-align: top;
// `;

// const Wrapper = styled.div`
//   margin: 0px 20px;
//   border-bottom: 1px solid rgba(0,0,0,0.1);
// `;

export default UploadScreen
